// formColumn.jsx
import { Tag, Tooltip } from "antd";

const ACTION_COLOR = {
  CREATE: "green",
  INSERT: "green",
  UPDATE: "blue",
  DELETE: "red",
  LOGIN: "cyan",
  LOGOUT: "orange",
  VIEW: "default",
  APPROVE: "green",
  REJECT: "red",
};

const formatDateTime = (val) => {
  if (!val) return "-";
  const date = new Date(val);
  if (Number.isNaN(date.getTime())) return val;
  return date.toLocaleString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const ellipsis = (val, width = 240) => (
  <Tooltip title={val || "-"}>
    <span
      style={{
        display: "inline-block",
        maxWidth: width,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      }}
    >
      {val || "-"}
    </span>
  </Tooltip>
);

const columns = [
  {
    title: "Waktu",
    dataIndex: "created_at",
    key: "created_at",
    width: 180,
    render: (val) => formatDateTime(val),
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    width: 140,
    render: (val) => val || "-",
  },
  {
    title: "Role",
    dataIndex: "role_name",
    key: "role_name",
    width: 130,
    render: (val) => val || "-",
  },
  {
    title: "Module",
    dataIndex: "module",
    key: "module",
    width: 140,
    render: (val) => val || "-",
  },
  {
    title: "Menu",
    dataIndex: "menu_name",
    key: "menu_name",
    width: 150,
    render: (val) => val || "-",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    width: 110,
    render: (val) =>
      val ? (
        <Tag color={ACTION_COLOR[String(val).toUpperCase()] || "default"}>
          {String(val).toUpperCase()}
        </Tag>
      ) : (
        "-"
      ),
  },
  {
    title: "Record ID",
    dataIndex: "record_id",
    key: "record_id",
    width: 130,
    render: (val) => val || "-",
  },
  {
    title: "Deskripsi",
    dataIndex: "description",
    key: "description",
    width: 260,
    render: (val) => ellipsis(val),
  },
  {
    title: "Endpoint",
    dataIndex: "endpoint",
    key: "endpoint",
    width: 240,
    render: (val, record) =>
      ellipsis(
        record?.http_method ? `${record.http_method} ${val || ""}`.trim() : val
      ),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 110,
    render: (val, record) => {
      const code = record?.response_code;
      const success =
        String(val).toUpperCase() === "SUCCESS" ||
        (typeof code === "number" && code >= 200 && code < 400);
      return (
        <Tag color={val ? (success ? "green" : "red") : "default"}>
          {val ? String(val).toUpperCase() : "-"}
          {code ? ` (${code})` : ""}
        </Tag>
      );
    },
  },
  {
    title: "IP Address",
    dataIndex: "ip_address",
    key: "ip_address",
    width: 140,
    render: (val) => val || "-",
  },
  {
    title: "Browser",
    dataIndex: "browser",
    key: "browser",
    width: 180,
    render: (val) => ellipsis(val, 160),
  },
  {
    title: "OS",
    dataIndex: "operating_system",
    key: "operating_system",
    width: 150,
    render: (val) => ellipsis(val, 140),
  },
  {
    title: "Source",
    dataIndex: "source",
    key: "source",
    width: 110,
    render: (val) => val || "-",
  },
];

const actionOptions = [
  { value: "CREATE", label: "Create" },
  { value: "UPDATE", label: "Update" },
  { value: "DELETE", label: "Delete" },
  { value: "LOGIN", label: "Login" },
  { value: "LOGOUT", label: "Logout" },
  { value: "VIEW", label: "View" },
  { value: "APPROVE", label: "Approve" },
  { value: "REJECT", label: "Reject" },
];

const statusOptions = [
  { value: "SUCCESS", label: "Success" },
  { value: "FAILED", label: "Failed" },
];

export { columns, actionOptions, statusOptions, formatDateTime };
